module.exports = "/_next/static/images/faucet-purr-f91d5c95b97f9c1f40ac630037fa48ce.webp";